const cookie = require('browser-cookies')
const editor = {
  state: {
    materialConditionData: {
      "duration": 0,                    // 时间范围， 全部：0  今天：1  七天：7 三十天：30  自定义：31
      "sorting": 0,                     // 排序方式：创建时间倒序(默认)：0   创建时间正序：1     更新时间倒序：2     更新时间正序：3
      "match_field": "all",             // 字段匹配类型：  全部：all    标题：title   正文：content   关键词：keywords    摘要：summary
      "keywords": "",                   // 关键词，没有时时空字符串
      "time_start": "",       // 自定义时间范围的开始时间
      "time_stop": "",        // 自定义时间范围的结束时间
      "flag_sys_source": "all",         // 来源类型： 全部：all  报题：news_recover  稿件库原创： mrp_original
      "flag_audit": "all",              // 是否审核： 全部：all  已审核：yes  未审核：no
      "flag_my_create": false,    // 与我相关： 我创建的： true   其他：false
      'flag_sign_and_issue': 'all', //是否签发
      'flag_push': 'all'
    },
    isElectron: false
  },
  mutations: {
    SET_ELECTRON_DATA: (state, data) => {
      state.isElectron = data
    }
  },
  actions: {}
}

export default editor
